import React from 'react';

import { BasicNavigation } from './BasicNavigation';

export const DocumentsNavigation: React.FC = () => <BasicNavigation />;
